import {useCallback, useEffect, useState} from "react";
import Cookies from "js-cookie";

export default function useCookie(name) {
  const [state, setState] = useState({
    value: Cookies.get(name)
  });


  useEffect(() => {
    if (state.value === null) {
      Cookies.delete(name, state.options);
    } else {
      Cookies.set(name, state.value, state.options);
    }
  }, [state]);

  return [
    state.value,
    useCallback((value, options = {}) => {
      setState({
        value: value.toString(),
        options: options
      });
    }, [name])
  ];
}
